
if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.variantIdInput.disabled = false;

        this.form.addEventListener(
          "submit",
          this.onSubmitHandler.bind(this)
        );

        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");

        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText =
          this.submitButton.querySelector("span");

        this.upsellVariantId = this.dataset.upsellVariantId;

        this.originalButtonText =
          this.submitButtonText?.textContent || "In den Warenkorb";

        /*
          GLANZIUM – Mobile Erfolgsmeldung.

          Die Produkt-Rail hat zwei Button-Beschriftungen:
          eine für Desktop und eine für Mobile.

          Beide müssen nach erfolgreichem Hinzufügen
          aktualisiert und anschließend wiederhergestellt
          werden.

          Alle anderen Produktbuttons verwenden weiterhin
          ihre bisherige einzelne Beschriftung.
        */

        const railLabels = this.submitButton.querySelectorAll(
          ".gz-rail-label-desktop, .gz-rail-label-mobile"
        );

        this.successLabels = railLabels.length
          ? Array.from(railLabels)
          : this.submitButtonText
            ? [this.submitButtonText]
            : [];

        this.originalSuccessLabels = this.successLabels.map(
          (element) => element.textContent
        );

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();

        if (
          this.submitButton.getAttribute("aria-disabled") === "true"
        ) {
          return;
        }

        this.handleErrorMessage();
        this.error = false;

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");

        const spinner =
          this.querySelector(".loading__spinner");

        if (spinner) {
          spinner.classList.remove("hidden");
        }

        const formData = new FormData(this.form);

        const variantInput =
          this.form.querySelector('[name="id"]');

        const skipCart =
          variantInput?.dataset?.skipCart === "true";

        const config = fetchConfig("javascript");

        config.headers["X-Requested-With"] =
          "XMLHttpRequest";

        delete config.headers["Content-Type"];

        if (
          this.cart &&
          typeof this.cart.getSectionsToRender === "function"
        ) {
          formData.append(
            "sections",
            this.cart
              .getSectionsToRender()
              .map((section) => section.id)
          );

          formData.append(
            "sections_url",
            window.location.pathname
          );

          if (
            typeof this.cart.setActiveElement === "function"
          ) {
            this.cart.setActiveElement(
              document.activeElement
            );
          }
        }

        config.body = formData;

        try {
          /* =====================================
             BESTEHENDE UPSELL-FUNKTION
             ===================================== */

          const cartResponse = await fetch(
            `${routes.cart_url}.js`
          );

          if (!cartResponse.ok) {
            throw new Error(
              "Warenkorb konnte nicht geladen werden."
            );
          }

          const cartState = await cartResponse.json();

          if (
            cartState.item_count === 0 &&
            this.upsellVariantId
          ) {
            const upsellResponse = await fetch(
              `${routes.cart_add_url}`,
              this.getUpsellProductConfig()
            );

            if (!upsellResponse.ok) {
              throw new Error(
                "Upsell-Produkt konnte nicht hinzugefügt werden."
              );
            }
          }

          /* =====================================
             PRODUKT HINZUFÜGEN
             ===================================== */

          const response = await fetch(
            `${routes.cart_add_url}`,
            config
          );

          const result = await response.json();

          if (!response.ok || result.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: "product-form",
              productVariantId: formData.get("id"),
              errors:
                result.errors || result.description,
              message: result.message,
            });

            this.handleErrorMessage(
              result.description ||
              result.message ||
              "Produkt konnte nicht hinzugefügt werden."
            );

            this.error = true;
            return;
          }

          /* =====================================
             DIREKT ZUM CHECKOUT
             Nur bei expliziter Einstellung
             ===================================== */

          if (skipCart) {
            window.location.href = "/checkout";
            return;
          }

          /* =====================================
             WARENKORB AKTUALISIEREN
             OHNE WEITERLEITUNG
             ===================================== */

          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "product-form",
            productVariantId: formData.get("id"),
            cartData: result,
          });

          /* Warenkorbstatus neu abrufen */

          const updatedCartResponse = await fetch(
            `${routes.cart_url}.js`
          );

          if (!updatedCartResponse.ok) {
            throw new Error(
              "Warenkorbstatus konnte nicht aktualisiert werden."
            );
          }

          const updatedCart =
            await updatedCartResponse.json();

          /* =====================================
             WARENKORB-SYMBOL AKTUALISIEREN
             ===================================== */

          this.updateCartIcon(updatedCart.item_count);

          /* =====================================
             ERFOLGSMELDUNG
             DESKTOP UND MOBILE
             ===================================== */

          this.showSuccessMessage();

          /* =====================================
             KEINE AUTOMATISCHE WEITERLEITUNG
             KEIN AUTOMATISCHER DRAWER
             ===================================== */

        } catch (error) {
          console.error(
            "GLANZIUM Warenkorb-Fehler:",
            error
          );

          this.handleErrorMessage(
            "Es ist ein Fehler aufgetreten. Bitte versuche es erneut."
          );

          this.error = true;

        } finally {
          this.submitButton.classList.remove("loading");

          if (spinner) {
            spinner.classList.add("hidden");
          }

          this.submitButton.removeAttribute(
            "aria-disabled"
          );
        }
      }

      /* =====================================
         WARENKORB-SYMBOL
         ===================================== */

      updateCartIcon(count) {
        const cartIcons =
          document.querySelectorAll(
            "#cart-icon-bubble"
          );

        cartIcons.forEach((cartIcon) => {
          let bubble =
            cartIcon.querySelector(
              ".cart-count-bubble"
            );

          if (count <= 0) {
            if (bubble) bubble.remove();
            return;
          }

          if (!bubble) {
            bubble = document.createElement("div");
            bubble.className = "cart-count-bubble";

            cartIcon.appendChild(bubble);
          }

          bubble.innerHTML = `
            <span aria-hidden="true">${count}</span>
            <span class="visually-hidden">
              ${count} Artikel im Warenkorb
            </span>
          `;
        });
      }

      /* =====================================
         ERFOLGSMELDUNG
         GLANZIUM DESKTOP + MOBILE
         ===================================== */

      showSuccessMessage() {
        if (!this.successLabels.length) return;

        clearTimeout(this.successTimeout);

        /*
          Alle relevanten Button-Beschriftungen
          aktualisieren.

          In der GLANZIUM Produkt-Rail sind das
          Desktop- und Mobile-Label.

          Bei normalen Produktseiten bleibt
          es bei einem einzigen Label.
        */

        this.successLabels.forEach((element) => {
          element.textContent = "✓ Hinzugefügt";
        });

        this.submitButton.classList.add(
          "gz-cart-success"
        );

        this.successTimeout = setTimeout(() => {
          /*
            Jede Beschriftung erhält wieder
            ihren ursprünglichen Text.
          */

          this.successLabels.forEach((element, index) => {
            element.textContent =
              this.originalSuccessLabels[index];
          });

          this.submitButton.classList.remove(
            "gz-cart-success"
          );
        }, 2000);
      }

      /* =====================================
         BESTEHENDE UPSELL-KONFIGURATION
         ===================================== */

      getUpsellProductConfig() {
        const upsellFormData = new FormData();

        upsellFormData.append(
          "id",
          this.upsellVariantId
        );

        upsellFormData.append(
          "quantity",
          1
        );

        const config = fetchConfig("javascript");

        config.headers["X-Requested-With"] =
          "XMLHttpRequest";

        delete config.headers["Content-Type"];

        config.body = upsellFormData;

        return config;
      }

      /* =====================================
         FEHLERMELDUNGEN
         ===================================== */

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(
            ".product-form__error-message-wrapper"
          );

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute(
          "hidden",
          !errorMessage
        );

        if (errorMessage && this.errorMessage) {
          this.errorMessage.textContent =
            errorMessage;
        }
      }

      /* =====================================
         SUBMIT-BUTTON
         ===================================== */

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute(
            "disabled",
            "disabled"
          );

          if (text && this.submitButtonText) {
            this.submitButtonText.textContent = text;
          }
        } else {
          this.submitButton.removeAttribute(
            "disabled"
          );

          if (this.submitButtonText) {
            this.submitButtonText.textContent =
              window.variantStrings.addToCart;
          }
        }
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    }
  );
}
